import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useMount } from "react-use";

import { PaginatedList } from "@/components/templates";
import { ActivitiesPageState } from "@/shared/domain";
import { useRouterHook } from "@/shared/hooks";
import * as tagManager from "@/tagManager";
import { useUserFeedback } from "@/userFeedback";

import { ActivitiesTable } from "../components";
import { useActitivitiesQueries } from "../useActivitiesQueries";

const ActivitiesPage: FC = () => {
    const {
        state: { featureType, policyholderId },
    } = useRouterHook<ActivitiesPageState>();
    const { id } = useParams();
    const { incUsageCount } = useUserFeedback();
    const { t } = useTranslation();
    const { useActitivitiesPageQuery } = useActitivitiesQueries({
        id,
        featureType,
        policyholderId: Number(policyholderId),
    });

    useMount(() => {
        incUsageCount();
        tagManager.pushViewItemListEvent("relatedActivities", "Related Activities");
    });

    const {
        page,
        setPage,
        orderBy,
        isFetching,
        handleSort,
        totalOfPages,
        result: activities,
        handlePageSizeChange,
    } = useActitivitiesPageQuery();

    const renderTable = (items: MyBrokerApi.Activity[]) => (
        <ActivitiesTable activities={items} orderBy={orderBy} handleSort={handleSort} />
    );

    return (
        <PaginatedList<MyBrokerApi.Activity>
            page={page}
            tableMode
            emptyListMessage={t("Activities.Empty")}
            pageTitle={t("Common.Activities")}
            renderTable={renderTable}
            isFetchingList={isFetching}
            isLoading={isFetching}
            setPage={setPage}
            totalOfPages={totalOfPages}
            items={activities}
            handlePageSizeChange={handlePageSizeChange}
        />
    );
};

export default ActivitiesPage;
